module.exports = __webpack_public_path__ + "00b7d6b298ad30005f0513fffe4fc1df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/3.jpg
// module id = 434
// module chunks = 0 2